import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/common.css";
import "./assets/swiper.min.css";
import "nprogress/nprogress.css";
// 引入element-ui的样式
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./plugins/element.js";
import locale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en"; // 引入英文语言包

import { AgGridVue } from "ag-grid-vue";
// 还原样式引入路径（移除dist目录）
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

// 还原组件注册方式（改回Vue.component）
Vue.component("AgGridVue", AgGridVue);

// 设置ElementUI的语言
locale.use(enLocale);
Vue.use(ElementUI);
Vue.config.productionTip = false;
// 设置全局 URL
Vue.prototype.$globalUrl =  process.env.VUE_APP_BASE_URL;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
